<template>
    <cic-popup
        :title="item.userGroupId ? 'Edit User Group' : 'New User Group'"
        :saveable="editing"
        @blur="$emit('blur')"
        @input="$emit('input')"
    >
        <div class="item-form">
            <ul>
                <li class="form-label-first">
                    {{ $t('User Group Name') }}
                </li>
                <li>
                    <cic-textbox
                        id="group_name"
                        :enabled="editing"
                        :value="item.name"
                        :maxlength="256"
                        @input="(val) => updateFieldValue('name', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Parent User Group') }}
                </li>
                <li>
                    <cic-select
                        id="group_parent"
                        :enabled="editing"
                        :value="item.parentId"
                        :options="
                            groups
                                .filter((x) => x.userGroupId !== item.userGroupId)
                                .map((x) => ({ value: x.userGroupId, label: x.name }))
                        "
                        :placeholder="$t('None')"
                        clearable
                        @input="(val) => updateFieldValue('parentId', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Address Line 1') }}
                </li>
                <li>
                    <cic-textbox
                        id="group_address1"
                        :enabled="editing"
                        :value="item.address1"
                        :maxlength="64"
                        @input="(val) => updateFieldValue('address1', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Address Line 2') }}
                </li>
                <li>
                    <cic-textbox
                        id="group_address2"
                        :enabled="editing"
                        :value="item.address2"
                        :maxlength="64"
                        @input="(val) => updateFieldValue('address2', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('City') }}
                </li>
                <li>
                    <cic-textbox
                        id="group_city"
                        :enabled="editing"
                        :value="item.city"
                        :maxlength="64"
                        @input="(val) => updateFieldValue('city', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Local Area') }}
                </li>
                <li>
                    <cic-select
                        id="group_area"
                        :enabled="editing"
                        :options="
                            areas[`_${item.countryId}`]
                                ? areas[`_${item.countryId}`].map((x) => ({ value: x.localAreaId, label: x.name }))
                                : []
                        "
                        :value="item.localAreaId > 0 ? item.localAreaId : null"
                        :placeholder="
                            $t(
                                areas[`_${item.countryId}`] && areas[`_${item.countryId}`].length > 0
                                    ? 'Please select...'
                                    : 'None',
                            )
                        "
                        clearable
                        @input="(val) => updateFieldValue('localAreaId', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('County') }}
                </li>
                <li>
                    <cic-textbox
                        id="group_county"
                        :enabled="editing"
                        :value="item.county"
                        :maxlength="64"
                        @input="(val) => updateFieldValue('county', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Country') }}
                </li>
                <li>
                    <cic-select
                        id="group_country"
                        :enabled="editing"
                        :options="
                            countries
                                .map((x) => ({ value: x.countryId, label: $t(x.name) }))
                                .sort((a, b) => (a.label > b.label ? 1 : -1))
                        "
                        :value="item.countryId > 0 ? item.countryId : null"
                        @input="(val) => updateFieldValue('countryId', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Postcode') }}
                </li>
                <li>
                    <cic-textbox
                        id="group_postcode"
                        :enabled="editing"
                        :value="item.postcode"
                        :maxlength="16"
                        @input="(val) => updateFieldValue('postcode', val)"
                    />
                </li>
            </ul>
        </div>
    </cic-popup>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import CicSelect from '@/components/inputs/CicSelect';
    import CicTextbox from '@/components/inputs/CicTextbox';

    export default {
        name: 'EditUserGroup',
        components: {
            CicPopup,
            CicSelect,
            CicTextbox,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
            groups: {
                type: Array,
                required: true,
            },
            areas: {
                type: Object,
                required: true,
            },
            countries: {
                type: Array,
                required: true,
            },
        },
        emits: ['blur', 'input', 'updateFieldValue'],
        data() {
            return {
                editing: false,
            };
        },
        created() {
            this.editing = !this.item.userGroupId || this.$store.hasRight('EDIT_USER_GROUPS');
        },
        methods: {
            updateFieldValue(field, val) {
                this.$emit('updateFieldValue', field, val);
            },
        },
    };
</script>
